module.exports = __webpack_public_path__ + "static/media/dolly-flatbed-alt.99426113.svg";